import styled from 'styled-components';

export interface MenuItemContainerProps {
  padding?: string;
}

export const MenuItemContainer = styled.div<MenuItemContainerProps>`
    padding: 15px;
`;